import gql from 'graphql-tag'

const getSelfService = (bookingNumber) => gql`
{
  selfService (bookingNumber: "${bookingNumber}") {
    options {
      id
      title
      description
    }
  }  
}`

export { getSelfService }
